import { useI18n } from "@core/i18n/i18n";
import { libraryFilterManager } from "@core/service-container";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React from "react";

export const NoExercisePlaceholder = (): JSX.Element => {
	const { format } = useI18n();
	return (
		<Placeholder onClick={() => libraryFilterManager.setSidebarVisible(true)}>
			<Text className="p-size-xs-semi-bold">
				{format("programBuilder.dayTable.noExercisePlaceholder.title")}
				<LibraryContainer>{format("programBuilder.dayTable.noExercisePlaceholder.libraryTitle")}</LibraryContainer>
			</Text>
		</Placeholder>
	);
};

const Text = styled.p`
	color: ${colors.grey};
	max-width: 60%;
`;

const LibraryContainer = styled.div`
	color: ${colors.primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 4px;
`;

const Placeholder = styled.div`
	display: grid;
	cursor: pointer;
	place-content: center;
	place-items: center;
	text-align: center;
	border-radius: 8px;
	background-color: ${colors.primaryBackground};
	height: 124px;
	border: 1px solid ${colors.transparent};
	:hover {
		border-color: ${colors.primary};
	}
	:active {
		background-color: ${colors.primary25};
	}
`;
